import React, { useEffect, useReducer } from 'react'
import { Flex } from '@grupoboticario/flora-react-flex'
import { AnimatePresence } from 'framer-motion'
import { Toast, ToastWrapper } from './Toast'
import { toastReducer, initialState as toastInitialState } from './toast-reducer'
import { ToastPayload } from './toast-reducer'
import { styled, FloraVariants } from '@grupoboticario/flora-react-system'

const StyledToastContainer = styled(Flex, {
  position: 'fixed',
  padding: '$1 0',
  zIndex: '$toast',
  variants: {
    origin: {
      'right-top': {
        right: 0,
        top: 0,
      },
      'right-bottom': {
        right: 0,
        bottom: 0,
      },
      'center-top': {
        left: '50%',
        transform: 'translateX(-50%)',
        top: 0,
      },
    },
  },
})

const containers = [
  {
    name: 'right-top',
  },
  {
    name: 'right-bottom',
    invert: true,
  },
  {
    name: 'center-top',
  },
]

interface ToastAppPros {
  bind(callbacks: { notify: Function; closeAll: Function }): void
}

export const ToastApp = ({ bind }: ToastAppPros) => {
  const [state, dispatch] = useReducer(toastReducer, toastInitialState)

  const removeToast = (_id: string, origin: string) => {
    dispatch({
      type: 'REMOVE_TOAST',
      payload: {
        _id,
        origin,
      },
    })
  }

  const closeAll = () => {
    dispatch({
      type: 'CLOSE_ALL_TOASTS',
      payload: {},
    })
  }

  const notify = ({
    kind,
    Icon,
    description,
    duration = 5000,
    origin = 'right-bottom',
    buttons,
    button,
    callback,
    callbacks,
    closeWhenClick = true,
    showIcon = true,
  }: ToastPayload) => {
    const _id = `data-flora-${Date.now()}`
    const timer = setTimeout(() => {
      removeToast(_id, origin)
    }, duration)

    dispatch({
      type: 'ADD_TOAST',
      payload: {
        description,
        variant: kind,
        buttons,
        button,
        duration,
        origin,
        timer,
        callback,
        callbacks,
        closeWhenClick,
        showIcon,
        Icon,
        _id,
      },
    })
  }

  useEffect(() => {
    bind({ notify, closeAll })
  }, [])

  const containerBoxes = containers.map((container) => ({
    ...container,
    items: state[container.name] || [],
  }))

  return (
    <>
      {containerBoxes.map((container) => (
        <StyledToastContainer
          direction={container.invert ? 'column' : 'column-reverse'}
          origin={container.name as FloraVariants<typeof StyledToastContainer>['origin']}
          key={container.name}
        >
          <AnimatePresence>
            {container.items?.map(({ kind, description, ...restToast }: ToastPayload) => (
              <ToastWrapper invert={container.invert} key={restToast._id}>
                <Toast
                  variant={kind}
                  {...(restToast as any)}
                  remove={() => removeToast(restToast._id as string, container.name)}
                >
                  {description}
                </Toast>
              </ToastWrapper>
            ))}
          </AnimatePresence>
        </StyledToastContainer>
      ))}
    </>
  )
}
